export default "__VITE_ASSET__1ad2f202__"